
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiChevronLeftGoogle as ObiChevronLeftGoogleElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-chevron-left-google.js';
 
 
 

 
 export const ObiChevronLeftGoogle = createComponent({
   react: React,
   tagName: 'obi-chevron-left-google',
   elementClass: ObiChevronLeftGoogleElement,
   events: {
     
   }
  });
 
 